import { render, staticRenderFns } from "./app-root.vue?vue&type=template&id=42317e8c&"
import script from "./app-root.vue?vue&type=script&setup=true&lang=js&"
export * from "./app-root.vue?vue&type=script&setup=true&lang=js&"
import style0 from "@/css/site.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports